if (!customElements.get('leile-account-popup')) {
  class LeileAccountPopup extends HTMLElement {
    constructor() {
      super();
      this.lastTrigger = null;
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.reposition = this.reposition.bind(this);
    }

    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.panel = this.querySelector('.leile-account-popup__panel');
      this.password = this.querySelector('[data-account-password]');
      document.addEventListener('click', this.onDocumentClick, true);
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('resize', this.reposition, { passive: true });

      this.querySelector('[data-password-toggle]')?.addEventListener('click', (event) => {
        const button = event.currentTarget;
        const showing = this.password?.type === 'text';
        if (this.password) this.password.type = showing ? 'password' : 'text';
        button.setAttribute('aria-pressed', String(!showing));
        button.setAttribute('aria-label', showing ? 'Show password' : 'Hide password');
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick, true);
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('resize', this.reposition);
    }

    onDocumentClick(event) {
      const trigger = event.target.closest('[data-leile-account-open]');
      if (trigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.open(trigger);
        return;
      }
      if (event.target.closest('[data-account-close]')) this.close();
    }

    onKeydown(event) {
      if (this.hidden) return;
      if (event.key === 'Escape') this.close();
      if (event.key !== 'Tab') return;
      const focusable = [...this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])')]
        .filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    open(trigger) {
      this.lastTrigger = trigger;
      this.hidden = false;
      this.reposition();
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.panel?.focus({ preventScroll: true });
      });
      document.documentElement.classList.add('leile-account-is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('leile-account-is-open');
      this.lastTrigger?.setAttribute('aria-expanded', 'false');
      window.setTimeout(() => {
        this.hidden = true;
        this.lastTrigger?.focus({ preventScroll: true });
      }, 280);
    }

    reposition() {
      if (this.hidden) return;
      const gap = Number(this.dataset.gap || 20);
      let anchor = this.lastTrigger?.closest('[data-leile-header], header, .header-wrapper, .section-header');
      if (!anchor) anchor = this.lastTrigger;
      const rect = anchor?.getBoundingClientRect();
      const top = Math.max(12, Math.min((rect?.bottom || 90) + gap, window.innerHeight - 150));
      this.style.setProperty('--leile-account-top', `${Math.round(top)}px`);
    }
  }

  customElements.define('leile-account-popup', LeileAccountPopup);
}
